import { useSuspenseQuery } from '@apollo/client/react';
import {
  Audit,
  ArbeitszeitAuditManager,
  ArbeitszeitAuditAenderung,
} from '../entities/Arbeitszeit';
import { GET_AUDIT_BY_ARBEITSZEIT_ID } from './graphql/queries';
import {
  GetAuditByArbeitszeitIdQuery,
  GetAuditByArbeitszeitIdQueryVariables,
} from '@/gql/graphql';
import { formatAttribut } from '../components/EditSheet/content/Historie/formatAttribut';
import { toArbeitszeitAuditAenderungsTyp } from '../entities/ArbeitszeitAuditAenderungsTyp';

export function useAudit(idArbeitszeit: string): {
  audit?: Audit[];
  error?: string;
} {
  const { data, error } = useSuspenseQuery<
    GetAuditByArbeitszeitIdQuery,
    GetAuditByArbeitszeitIdQueryVariables
  >(GET_AUDIT_BY_ARBEITSZEIT_ID, {
    variables: { idArbeitszeit },
    fetchPolicy: 'network-only',
  });

  if (error) {
    return { error: error.message, audit: [] };
  }

  const auditData = data.arbeitszeitById?.audit ?? [];

  return {
    audit: auditData
      .map((audit) => {
        if (audit && audit.__typename === 'Audit') {
          return new Audit(
            audit.id ?? '',
            audit.typ ?? '',
            toArbeitszeitAuditAenderungsTyp(audit.aenderungsTyp),
            audit.aenderungsdatum
              ? new Date(audit.aenderungsdatum)
              : new Date(),
            audit.geaendertVon ?? '',
            audit.geaendertVonEmail ?? '',
            audit.manager
              ? new ArbeitszeitAuditManager(
                  audit.manager.email ?? '',
                  audit.manager.vorname ?? '',
                  audit.manager.nachname ?? '',
                )
              : undefined,
            (audit.aenderungen ?? []).map(
              (aenderung) =>
                new ArbeitszeitAuditAenderung(
                  (aenderung.attribut ?? '').charAt(0).toUpperCase() +
                    (aenderung.attribut ?? '').slice(1).toLocaleLowerCase(),
                  formatAttribut(
                    aenderung.attribut ?? '',
                    aenderung.nachher ?? null,
                  ),
                  formatAttribut(
                    aenderung.attribut ?? '',
                    aenderung.vorher ?? null,
                  ),
                ),
            ),
          );
        }
        return null;
      })
      .filter((audit) => audit !== null),
  };
}
